const MODERN_KPI_STORES = new Set([
  'magasin test mpl',
  'vapostore montpellier',
]);

export const isModernKpiStore = store => MODERN_KPI_STORES.has(String(store?.name || '')
  .trim()
  .replace(/\s+/g, ' ')
  .toLowerCase());

export const getModernKpiViews = ({ isAdmin, isResponsable, username }) => {
  const normalizedUsername = String(username || '').trim().toLowerCase();
  const limitedUser = normalizedUsername === 'laure' || normalizedUsername === 'kelvin';
  if (limitedUser) return ['statistics', 'month'];
  return [
    'statistics',
    'month',
    'pilot',
    ...(isAdmin || isResponsable ? ['history', 'planning'] : []),
  ];
};
